import encoding from 'encoding-japanese'

export function extractFilenameFromContentDisposition(contentDisposition, defaultFileName) {
  const filenameRegex = /filename[^;=\n]*=(['"].*?\2|[^;\n]*)/
  const [_matches, fileName] = contentDisposition.match(filenameRegex)

  return fileName ? fileName.replace(/['"]/g, '') : defaultFileName
}

export function saveDataAsTsvFile(filename, content, contentType) {
  const uniArray = encoding.stringToCode(content)
  const sjisArray = encoding.convert(uniArray, {
    to: 'UTF-8',
    from: 'UNICODE',
  })
  const unit8Array = new Uint8Array(sjisArray)
  /**
   * BOM document https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
   * Prepend UTF-8 BOM (hexadecimal) byte sequence EF BB BF to data
   */
  const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), unit8Array], { type: contentType })

  const link = document.createElement('a')
  const url = (window.URL || window.webkitURL).createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('charset', 'utf-8')
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => (window.URL || window.webkitURL).revokeObjectURL(link.href), 200)
}
